import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../_utility/AxiosConfig';

const Event = () => {
    const [events, setEvents] = useState([]);
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    useEffect(() => {
        const fetchEvents = async () => {
            if (!loading) {
                setLoading(true);
                try {
                    const res = await api.get('/api/events');
                    setEvents(res.data.data);
                } catch (error) {
                    console.error("Error fetching events:", error);
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchEvents();
    }, []);
    

    return (
        <section>
            <div className="inn-body-section">
                <div className="container-fuild">
                    <div className="page-head text-center">
                        <h2 style={{ fontSize: '33px' }}>Our Events</h2>
                        <div className="head-title">
                            <div className="hl-1"></div>
                            <div className="hl-2"></div>
                            <div className="hl-3"></div>
                        </div>
                        <p style={{ maxWidth: '750px', display: 'inline-block' }}>
                            At Younic Home, our events foster friendship, enhance skills, and celebrate diversity — all within a vibrant and welcoming community.
                        </p>
                    </div>

                    <div className="content-section event-section">
                        <div className="col-sm-10 mx-auto">
                                {loading ? (
                                    <div className="masonry">
                                        {Array.from({ length: 12 }).map((_, index) => (
                                            <div className="room_card_single" key={index}>
                                                <div className="ph-item p-0 border-0">
                                                    <div className="ph-col-12 p-0">
                                                        <div className="ph-picture"></div>
                                                        <div className="ph-row">
                                                            <div className="ph-col-6"></div>
                                                            <div className="ph-col-4 empty"></div>
                                                            <div className="ph-col-2"></div>
                                                            <div className="ph-col-8"></div>
                                                            <div className="ph-col-4 empty"></div>
                                                            <div className="ph-col-12"></div>
                                                            <div className="ph-col-6"></div>
                                                            <div className="ph-col-6 empty"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : events.length > 0 ? (
                                    <div className="masonry">
                                        {events.map((event, index) => (
                                            <div className="event-item" key={index}>
                                                <img 
                                                    src={event?.thumbnail?.[0]?.data_url} 
                                                    alt={event?.name || 'Event Image'} 
                                                />
                                                <div className="event-content">
                                                    <h3 className="event-title">{event?.name}</h3>
                                                    <span className="event-date">{event?.sort_description}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className='text-center'><p className="alert alert-primary" style={{ 'margin':'0 auto', 'display':'inline' }} role="alert">Sorry! no events found!.</p></div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Event;